import { motion } from 'framer-motion';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import './Testimonials.css';

// Sample testimonials data – replace with your own config
const testimonials = [
  {
    name: 'Priya & Arjun',
    event: 'Destination Wedding – Udaipur',
    quote:
      'Jayraj made our dream wedding a reality. Every detail was flawless, and we felt completely taken care of. An unforgettable experience!',
  },
  {
    name: 'Usha & Akash',
    event: 'Trijuginarayan – Uttarakhand',
    quote:
      'From the venue selection to the floral arrangements, everything was beyond our expectations. We are eternally grateful.',
  },
  {
    name: 'Ananya & Rohan',
    event: 'Grand Palace Wedding – Jaipur',
    quote:
      'The team handled every aspect with such grace and professionalism. Our guests are still talking about the magical atmosphere.',
  },
];

export default function Testimonials() {
  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="testimonials-header"
        >
          <p className="testimonials-subtitle">Testimonials</p>
          <h2 className="playfair-display testimonials-title">
            Loved by Couples Who Wanted Something Extraordinary
          </h2>
          <p className="testimonials-description">
            Their stories reflect the elegance, care, and detail that define every celebration we plan.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="testimonials-grid">
          {testimonials.map((item, index) => (
            <motion.blockquote
              key={item.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -8 }}
              className="testimonials-card group"
            >
              <div>
                {/* Top Row: Quote Icon & Star Rating */}
                <div className="testimonials-card-header">
                  <FaQuoteLeft className="testimonials-quote-icon" />
                  <div className="testimonials-stars">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="testimonials-star" />
                    ))}
                  </div>
                </div>

                {/* Quote Body */}
                <p className="playfair-display testimonials-quote">“{item.quote}”</p>
              </div>

              {/* Author Footer */}
              <footer className="testimonials-footer">
                <cite className="testimonials-author">{item.name}</cite>
                <span className="testimonials-event">{item.event}</span>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}